export const LIVE_STAGE = {
  // 暂未开始
  NOT_STARTED: 'not_started',
  // 直播进行中
  ONGOING: 'ongoing',
  // 暂停直播
  PAUSED: 'paused',
  // 结束直播
  ENDED: 'ended',
}

export const PLAY_STATE = {
  // 播放中
  PLAYING: 'playing',
  // 播放暂停
  PAUSED: 'paused',
}

export const LINE_TYPE = {
  // rtc播放
  RTC: 'rtc',
  // 快直播
  LEB: 'leb',
  // cdn播放
  CDN: 'cdn',
}

export const LAYOUT = {
  // 横屏展示
  HORIZONTAL: 'horizontal',
  // 竖屏展示
  VERTICAL: 'vertical',
}
